import {
  AiOutlinePlusCircle,
  AiOutlineRise,
  AiOutlineSearch,
} from "react-icons/ai";
import { FaCheckCircle } from "react-icons/fa";
import { IoIosLaptop } from "react-icons/io";
import jobPostIcon from "../../../assests/jobPostIcon.svg";
import mcqTestIcon from "../../../assests/svg/mcqTestIcon.svg";
import { ImSortAmountAsc } from "react-icons/im";
import { Table } from "../../dashboard/viewCredits";
import { useEffect, useState } from "react";
import { useStores } from "../../../store";
import { useNavigate } from "react-router-dom";
import noSubcriptionsImage from "../../../assests/noSubscriptions.png";
import { RiShareBoxLine } from "react-icons/ri";
import { useObserver } from "mobx-react";
import { toJS } from "mobx";
import { ConvertTimeStamptoDate } from "../../../services/reusable";
import { name } from "../../../services/white_label";

// import UserStore from "../../../store/user_store";

export default function PreviousSubscription({}) {
  const navigate = useNavigate();
  const { UserStore, RecuiterStore } = useStores();
  const [subscriptions, setSubscriptions] = useState([]);
  const URL = window.location.href;
  const isCompany = URL.includes("company") ? true : false;
  useEffect(() => {
    // if (RecuiterStore.refreshObject.settings === 0) {
    UserStore.getTransactions({});
    // RecuiterStore.refreshObject.settings = 1;
    // }
  }, []);

  useEffect(() => {
    console.log("subscriptions12", toJS(UserStore.previousSubscriptions));
    setSubscriptions(toJS(UserStore.previousSubscriptions));
  }, [UserStore.previousSubscriptions]);

  return useObserver(() => (
    <div
      className={`flex flex-col max-w-[100%]  mb-10 md:justify-center ${
        !isCompany && " md:border-t lg:border-t p-4"
      } lg:flex lg:text-xl   lg:justify-center  `}
    >
      {subscriptions ? (
        <>
          <div className="flex justify-between items-center p-2 md:px-6  ">
            <h1 className="md:text-xl text-lg font-bold">
              Subscription overview
            </h1>
            <button
              className="bg-primary text-white text-xs whitespace-nowrap gil-med md:px-4 px-3 py-2 md:py-2 gap-2 flex items-center justify-between rounded-md md:mt-4"
              onClick={() => {
                if (isCompany) {
                  if (name() !== "Naukritube") {
                    navigate("/company/subscription");
                  } else {
                    navigate("/company/pricing-plans1");
                  }
                } else {
                  if (name() !== "Naukritube") {
                    navigate("/dashboard/subscription");
                  } else {
                    navigate("/dashboard/pricing-plans1");
                  }
                }
              }}
            >
              <AiOutlineRise className="md:text-lg" /> <span>Upgrade plan</span>
            </button>
          </div>
          <div className="bg-[#181818] text-white md:p-6 p-4 px-2 m-2 md:mx-4 rounded-xl shadow-lg w-auto">
            <div className="flex justify-between items-center px-2 md:px-6 flex-wrap">
              <div className="flex flex-row md:gap-4 gap-4 items-center">
                <h2 className="md:text-xl text-base  gil-med">
                  Current plan:{" "}
                  <span className="text-orange-500">
                    {subscriptions?.planId?.name}
                  </span>
                </h2>
                <li className=" text-green-400 items-center justify-center   text-xs md:text-sm">
                  Active
                </li>
              </div>
              <p className="text-gray-500 text-sm md:block hidden">
                Subscribed on: {ConvertTimeStamptoDate(subscriptions.createdAt)}
              </p>
            </div>
            <div
              className={`grid grid-cols-1 tc2:grid-cols-2  md:gap-6 gap-2 mt-2 md:mt-6 ${
                !isCompany
                  ? "md:grid-cols-5 lg:grid-cols-5"
                  : "md:grid-cols-4 lg:grid-cols-4"
              }`}
            >
              <PlanItem
                title="Interview usage"
                used={
                  subscriptions?.featureUsage
                    ? subscriptions?.featureUsage[1]?.usedCount
                    : 0
                }
                total={
                  subscriptions?.featureUsage
                    ? subscriptions?.featureUsage[1]?.limit
                    : 0
                }
                color="text-orange-400 "
                border="tc2:border-r tc2:border-dashed tc2:border-gray-400"
                icon={
                  <IoIosLaptop className="text-xl text-white rounded-full " />
                }
              />
              <PlanItem

                title={ isCompany ?"Job postings" : "Job applications"}
                used={
                  subscriptions?.featureUsage
                    ? subscriptions?.featureUsage[5]?.usedCount
                    : 0
                }
                total={
                  subscriptions?.featureUsage
                    ? subscriptions?.featureUsage[5]?.limit
                    : 0
                }
                color="text-orange-400 "
                border="md:border-r md:border-dashed md::border-gray-400"
                icon={
                  <span className="w-4">
                    <img
                      src={jobPostIcon}
                      className="text-white "
                      alt="jobPostIcon"
                    />
                  </span>
                }
              />
              <PlanItem
                title="Resume Sorting"
                used={
                  subscriptions?.featureUsage
                    ? subscriptions?.featureUsage[0]?.usedCount
                    : 0
                }
                total={
                  subscriptions?.featureUsage
                    ? subscriptions?.featureUsage[0]?.limit
                    : 0
                }
                color="text-orange-400 "
                border="tc2:border-r tc2:border-dashed tc2:border-gray-400"
                icon={
                  <ImSortAmountAsc className="text-lg text-white rounded-full " />
                }
              />
              {!isCompany && (
                <PlanItem
                  title="MCQ tests"
                  used={
                    subscriptions?.featureUsage
                      ? subscriptions?.featureUsage[2]?.usedCount
                      : 0
                  }
                  total={
                    subscriptions?.featureUsage
                      ? subscriptions?.featureUsage[2]?.limit
                      : 0
                  }
                  color="text-orange-400"
                  border="md:border-r md:border-dashed md::border-gray-400"
                  icon={
                    <span className="w-4">
                      <img
                        src={mcqTestIcon}
                        className="text-white "
                        alt="jobPostIcon"
                      />
                    </span>
                  }
                />
              )}

              <div className="flex md:flex-col gap-2 md:gap-0 mt-4 md:mt-0 justify-between px-2 md:px-6">
                <div>
                  <p className="text-base gil-med text-white">
                    Increase plan Limit
                  </p>
                  {/* <p className="text-xs text-gray-300 ">
                    You can get individual assessments
                  </p> */}
                </div>

                <button
                  className="group w-fit relative overflow-hidden rounded-lg bg-primary px-4 py-2 text-white hover:bg-primary/90 active:bg-primary/90 outline-none transition-all duration-300 ease-in-out hover:scale-[1.02] active:scale-[0.98] flex items-center gap-2 text-sm font-medium"
                  onClick={() => {
                    if (isCompany) {
                      if (name() !== "Naukritube") {
                        navigate("/company/subscription");
                      } else {
                        navigate("/company/pricing-plans1");
                      }
                    } else {
                      if (name() !== "Naukritube") {
                        navigate("/dashboard/subscription");
                      } else {
                        navigate("/dashboard/pricing-plans1");
                      }
                    }
                  }}
                >
                  <span className="relative z-10">Purchase</span>
                  <AiOutlinePlusCircle className="relative z-10 text-lg transition-transform group-hover:rotate-90 duration-300" />
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/80 to-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </button>
              </div>
            </div>
          </div>
          <div className=" m-2 md:mx-4">
            {/* <div className="flex justify-between items-center p-2 md:px-6">
              <p className="text-[#000000] font-semibold text-lg md:text-xl lg:text-xl whitespace-nowrap">
                Transaction History
              </p>
              <div className=" tc1:hidden sm:block sm:flex pl-3 pr-3 py-1 items-center border border-[#FF6B00] rounded-lg md:pl-5 md-pr-5 lg:pl-5 lg:pr-5 ">
                <input
                  //  onKeyPress={(e) => {
                  //    if (e.key === "Enter") {
                  //      // alert(e.target.value);
                  //      UserStore.getTransactions({ transactionId: e.target.value });
                  //    }
                  //  }}
                  //  onChange={(e) => {
                  //    if (e.target.value.length === 0) {
                  //      UserStore.getTransactions({});
                  //    }
                  //  }}
                  type="text"
                  placeholder="Search by ID"
                  className=" md:w-fit lg:w-fit text-xs md:text-sm lg:text-sm w-[90%] h-7 border-none outline-none rounded-l-md"
                />

                <AiOutlineSearch className="md:text-xl sm:text-lg items-center justify-center text-[#FF6B00]" />
              </div>
            </div> */}
            {/* <Table data={UserStore?.transactions} /> */}
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center justify-center">
          <div className="flex flex-col md:flex-row md:gap-10 mt-10 md:w-[70%] justify-center items-center p-6">
            <img
              src={noSubcriptionsImage}
              // width={400}
              alt="noSubcriptionsImage"
            />
            <div className="flex-col justify-center items-center md:items-start mt-5">
              <h1 className="md:text-2xl text-xl gil-med text-primary">
                No subscriptions found
              </h1>
              <p className="text-base text-gray-800 mt-2">
                You're not subscribed yet! 🚀 Unlock the full potential of
                Reaidy.io by choosing a plan.
              </p>
              <button
                className="bg-primary text-white text-sm md:text-base whitespace-nowrap gil-med md:px-4 px-4 py-2 md:py-2 gap-2 flex items-center justify-between rounded-full mt-4"
                onClick={() => {
                  if (isCompany) {
                    if (name() !== "Naukritube") {
                      navigate("/company/subscription");
                    } else {
                      navigate("/company/pricing-plans1");
                    }
                  } else {
                    if (name() !== "Naukritube") {
                      navigate("/dashboard/subscription");
                    } else {
                      navigate("/dashboard/pricing-plans1");
                    }
                  }
                }}
              >
                <span>Subscribe Now!</span>
                <RiShareBoxLine className="text-white md:text-base" />{" "}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  ));
}

const PlanItem = ({ title, used, total, color, icon, border }) => {
  return (
    <div className={`flex flex-col mt-4 md:mt-0 px-2 md:px-6 ${border}`}>
      <p className="text-base gil-med text-white gap-1 md:gap-2 flex items-center">
        {icon}
        {title}
      </p>
      <p className={`md:text-sm text-xs text-white my-1 mt-1 md:mt-4`}>
        <span className={`${color} text-sm md:text-base gil-med`}>{used}</span>{" "}
        / {total} Used
      </p>
      <Progress
        value={total > 0 ?  100 - ( (used/total) * 100 ) : 0}
        className="mt-2 bg-gray-700 h-2"
      />
    </div>
  );
};

const Progress = ({ value }) => {
  return (
    <div className="relative h-2 bg-white rounded-md overflow-hidden">
      <div
        className="bg-orange-400 h-full rounded-full transition-all"
        style={{ width: `${value}%` }}
      />
    </div>
  );
};
